/* Quiz DB engine: shows one screen of window.QZ_SCREENS at a time on a single Shopify page.
 * Each screen keeps its own HTML, CSS and script from Funnelish. Only the current screen is in the DOM,
 * so the class names and ids that the screens share never clash. Step number is kept in ?step=N,
 * so the browser back button works and analytics see one page view per step. */
(function () {
  var root = document.getElementById('qz-root');
  var screens = window.QZ_SCREENS || [];
  var base = window.QZ_ASSET_BASE || '';
  var finalUrl = window.QZ_FINAL_URL || '';
  var total = screens.length;
  var current = 0;
  if (!root || !total) return;

  function stepFromUrl() {
    var n = parseInt(new URLSearchParams(window.location.search).get('step'), 10);
    return n >= 1 && n <= total ? n : 1;
  }

  function urlForStep(n) {
    var u = new URL(window.location.href);
    if (n === 1) u.searchParams.delete('step'); else u.searchParams.set('step', n);
    return u.pathname + u.search + u.hash;
  }

  // Run the screen's scripts as if the page had just loaded (DOMContentLoaded handlers run at once).
  function runScripts(container) {
    var add = document.addEventListener;
    document.addEventListener = function (type, fn, opts) {
      if (type === 'DOMContentLoaded') { setTimeout(fn, 0); return; }
      return add.call(document, type, fn, opts);
    };
    try {
      container.querySelectorAll('script').forEach(function (old) {
        var s = document.createElement('script');
        for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
        s.textContent = old.textContent;
        old.parentNode.replaceChild(s, old);
      });
    } finally {
      document.addEventListener = add;
    }
  }

  function render(n) {
    current = n;
    window.__qzPage = n;
    root.innerHTML = screens[n - 1].split('__QZA__').join(base);
    if (finalUrl && n === total) {
      root.querySelectorAll('a[href*="primal-storm.com/products/primal-storm"]').forEach(function (a) { a.setAttribute('href', finalUrl); });
    }
    runScripts(root);
    window.scrollTo(0, 0);
  }

  function go(n, replace) {
    n = Math.max(1, Math.min(total, n));
    if (n === current) return;
    var url = urlForStep(n);
    if (replace) history.replaceState({ qzStep: n }, '', url); else history.pushState({ qzStep: n }, '', url);
    render(n);
    // Funnelish fired a page_view per step page; GTM gets the same per step here
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'page_view', url: window.location.href, quiz_step: n });
    // PostHog's history_change pageviews ignore query-only changes, so ?step=N needs its own $pageview
    if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture('$pageview', { quiz_step: n });
  }
  window.__qzGo = function (n) { go(n); };

  // Links to /page-N of the Funnelish funnel are steps of this quiz. No root.contains() check on purpose:
  // a link of a screen that was just swapped out is detached, and must still not leave for Funnelish.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var m = a.getAttribute('href').match(/\/quiz-[\w-]+\/page-(\d+)/);
    if (!m) return;
    e.preventDefault();
    go(parseInt(m[1], 10));
  });

  window.addEventListener('popstate', function () { render(stepFromUrl()); });

  var first = stepFromUrl();
  history.replaceState({ qzStep: first }, '', window.location.href);
  render(first);
})();
